/** Chart series colors coordinated with the dashboard's light/purple theme (see
 * BLOCK_OVERVIEW_COLORS in styles/theme/index.ts) — kept separate from the shared
 * CHART_COLORS constant so old dark-themed pages elsewhere in the app are unaffected. */
const DASHBOARD_CHART_COLORS = [
  '#8B5CF6', // purple (primary)
  '#3BA7FA', // blue (info)
  '#22C55E', // green (success)
  '#F97066', // coral
  '#FBBF24', // amber
  '#EC4899', // pink
  '#14B8A6', // teal
  '#6366F1', // indigo
  '#F59E0B', // orange
  '#A78BFA', // light purple
];

export default DASHBOARD_CHART_COLORS;
